module.exports = __webpack_public_path__ + "607a4fc25d952d791a155afb764c5da7.jpg";